"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Users16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", d: "M14.5 3.5c0 .866-.314 1.658-.835 2.269A4.997 4.997 0 0 1 16 10h-2a3 3 0 0 0-5.63-1.446 3.503 3.503 0 0 1-.705 3.215A4.996 4.996 0 0 1 10 16H8a3 3 0 1 0-6 0H0c0-1.782.932-3.346 2.335-4.231a3.5 3.5 0 0 1 4.851-5.002c.33-.388.717-.726 1.149-.998A3.5 3.5 0 1 1 14.5 3.5ZM6.415 10a1.498 1.498 0 0 0-.216-1.401A1.5 1.5 0 1 0 6.415 10ZM12.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z", clipRule: "evenodd" }));
}
function Users16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Users16Svg, Object.assign({}, svgProps)));
}
exports.default = Users16;
//# sourceMappingURL=Users16.js.map